export default __webpack_public_path__ + "static/media/cbcSala1.3e0e4864.jpg";